module.exports = __webpack_public_path__ + "4f8bb28722068f7b666582a39c7035b8.woff";